<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="8">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <b-form @submit="checkCode">
                  <h1>{{ $t('twoFactorAuth') }}</h1>
                  <p class="text-muted">{{ $t('enabledTwoFactorAuth') }}</p>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend><b-input-group-text></b-input-group-text></b-input-group-prepend>
                    <b-form-input type="text" class="form-control" :placeholder="this.$t('code')" autocomplete="email" v-model="code"/>
                  </b-input-group>
                  <b-row>
                    <b-col cols="6">
                      <b-button type="submit" variant="primary" class="px-4">{{ $t('submit') }}</b-button>
                    </b-col>
                    <b-col cols="6" class="text-right">
                      <b-form-checkbox
                        id="remember_device"
                        name="remember_device"
                        v-model="remember"
                        >
                        {{ $t('rememberDevice') }}
                    </b-form-checkbox>
                    </b-col>
                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import Axios from 'axios';

export default {
  name: 'TwoFactorAuth',
  data: () => {
    return {
      code: "",
      remember: false
    }
  },
  methods: {
    clientFactory() {
      const http = Axios.create({
        baseURL: this.$env.get("API_HOST"),
        timeout: 10000
      });

      http.defaults.withCredentials = true

      return http
    },

    checkCode(e) {
      e.preventDefault()

      this.clientFactory().post("/v1/user/two-factor-auth", {
          code: this.code,
          remember: this.remember
      }
      )
      .then(() => {
          this.$router.push("/")
      }).catch(err => {
          if (err.response !== undefined) {
            this.$mainDialog.msgBoxOk(err.response.data.message);
            return
          }
      })
    }
  }
}
</script>
